module.exports = __webpack_public_path__ + "static/nikunj1-0d371c382412d6a15cf9cd4accba7f52.png";